module.exports = __webpack_public_path__ + "static/media/mip1.553c8aa7.png";